import { useCallback, useState } from 'react'

export function useFocusState({ onBlur, onFocus }: { onBlur?: Function; onFocus?: Function }) {
  const [isFocused, setFocus] = useState(false)

  const handleFocus = useCallback(
    (...args: any) => {
      setFocus(true)
      if (onFocus) {
        onFocus(args)
      }
    },
    [onFocus]
  )
  const handleBlur = useCallback(
    (...args: any) => {
      setFocus(false)
      if (onBlur) {
        onBlur(args)
      }
    },
    [onBlur]
  )

  return {
    isFocused,
    handleFocus,
    handleBlur,
  }
}

export function useHelperText({ error, helperText }: { error?: React.ReactNode; helperText?: React.ReactNode }) {
  const isVisible = Boolean(error) || Boolean(helperText)
  const children = error || helperText
  return {
    isVisible,
    children,
  }
}
